import { GHLLanguageKeys as e } from "./ghl-ui.es273.js";
const t = {
  name: e.finnish,
  global: {
    undo: "Kumoa",
    redo: "tehdä uudelleen",
    confirm: "Vahvista",
    clear: "Selvä",
    more: "lisää",
    cancel: "Peruuttaa"
  },
  Popconfirm: {
    positiveText: "vahvista",
    negativeText: "Peruuta"
  },
  Cascader: {
    placeholder: "Valitse, ole hyvä",
    loading: "Ladataan",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "selvä",
    now: "Nyt",
    confirm: "Vahvistaa",
    selectTime: "Valitse aika",
    selectDate: "Valitse päivämäärä",
    datePlaceholder: "Valitse päivämäärä",
    datetimePlaceholder: "Valitse päivämäärä ja aika",
    monthPlaceholder: "Valitse kuukausi",
    yearPlaceholder: "Valitse vuosi",
    quarterPlaceholder: "Valitse neljännes",
    startDatePlaceholder: "Aloitus päivämäärä",
    endDatePlaceholder: "Päättymispäivämäärä",
    startDatetimePlaceholder: "Aloitusajankohta ja -aika",
    endDatetimePlaceholder: "Päätöspäivä ja aika",
    startMonthPlaceholder: "Aloituskuukausi",
    endMonthPlaceholder: "Lopun kuukausi",
    monthBeforeYear: !0,
    firstDayOfWeek: 6,
    today: "Tänään"
  },
  DataTable: {
    checkTableAll: "Valitse kaikki taulukosta",
    uncheckTableAll: "Poista valinnat taulukosta",
    confirm: "Vahvista",
    clear: "Selvä",
    apply: "Ansøg",
    filters: "Suodattimet",
    sort: "Lajitella"
  },
  LegacyTransfer: {
    sourceTitle: "Lähde",
    targetTitle: "kohde"
  },
  Transfer: {
    selectAll: "Valitse kaikki",
    unselectAll: "Poista kaikki valinnat",
    clearAll: "Kirkas"
  },
  Empty: {
    description: "Ei dataa"
  },
  Select: {
    placeholder: "Valitse, kiitos"
  },
  TimePicker: {
    placeholder: "Valitse aika",
    positiveText: "OK",
    negativeText: "peruuttaa",
    now: "Nyt"
  },
  Pagination: {
    goto: "Siirry",
    selectionSuffix: "sivu",
    next: "Seuraava",
    previous: "Edellinen"
  },
  DynamicTags: {
    add: "Lisää"
  },
  Log: {
    loading: "Lataus"
  },
  Input: {
    placeholder: "Syötäthän tiedot"
  },
  InputNumber: {
    placeholder: "Syötä kiitos"
  },
  DynamicInput: {
    create: "Luoda"
  },
  ThemeEditor: {
    title: "Teeman muokkaaja",
    clearAllVars: "Poista kaikki muuttujat",
    clearSearch: "Tyhjennä haku",
    filterCompName: "Suodatin osan nimi",
    filterVarName: "Suodattimen muuttujan nimi",
    import: "Tuonti",
    export: "Vienti",
    restore: "Nollaa oletusarvoihin"
  },
  Image: {
    tipPrevious: "Edellinen kuva (←)",
    tipNext: "Seuraava kuva (→)",
    tipCounterclockwise: "Vastapäivään",
    tipClockwise: "Myötäpäivään",
    tipZoomOut: "Zoomaa ulos",
    tipZoomIn: "Lähennä",
    tipClose: "Sulje (Esc)",
    tipOriginalSize: "Zoomaa alkuperäiseen kokoon"
  },
  SortFilter: {
    heading: "Lajittele ja suodata",
    sortHeading: "Lajittele mukaan",
    newestFirst: "Uusimmat ensin",
    oldestFirst: "Vanhimmat ensin",
    ascending: "Nouseva",
    descending: "Laskeva",
    aToZ: "A-Ö",
    zToA: "Ö-A",
    apply: "Käytä",
    clear: "Tyhjennä",
    cancel: "Peruuta",
    filters: "Suodattimet"
  },
  IconPicker: {
    noMatchingFound: "Ei vastaavia tuloksia löytynyt"
  }
};
export {
  t as fi
};
